(function () {
  'use strict';

  if (window.__joyeTeeGallery) return;
  window.__joyeTeeGallery = true;

  var lastActive = null;
  var queued = false;

  // Teeinblue draws each thumbnail mockup at its own inline px size; scale it
  // down to the box joye-teeinblue-gallery.css gives the thumbnail.
  function fitThumbs(thumbs) {
    var first = thumbs.querySelector('.tee-thumbnail');
    if (!first) return;
    var drawn = parseFloat(first.style.width);
    if (!drawn || !first.clientWidth) return;
    var scale = String(first.clientWidth / drawn);
    if (thumbs.style.getPropertyValue('--joye-tee-thumb-scale') !== scale) {
      thumbs.style.setProperty('--joye-tee-thumb-scale', scale);
    }
  }

  // The CSS turns off Teeinblue's translateX paging, so keep the active
  // thumbnail in view by scrolling the track instead.
  function revealActive(thumbs) {
    var track = thumbs.querySelector('.tee-thumbnails__track');
    var active = thumbs.querySelector('.tee-thumbnail--active');
    if (!track || !active || active === lastActive) return;
    lastActive = active;

    var t = track.getBoundingClientRect();
    var a = active.getBoundingClientRect();
    var top = a.top < t.top ? a.top - t.top : a.bottom > t.bottom ? a.bottom - t.bottom : 0;
    var left = a.left < t.left ? a.left - t.left : a.right > t.right ? a.right - t.right : 0;
    if (top || left) track.scrollBy({ top: top, left: left, behavior: 'smooth' });
  }

  function update() {
    queued = false;
    var thumbs = document.querySelector('.tee-gallery .tee-thumbnails');
    if (!thumbs) return;
    fitThumbs(thumbs);
    revealActive(thumbs);
  }

  function schedule() {
    if (queued) return;
    queued = true;
    // Not requestAnimationFrame: it stalls while the page isn't being painted
    // (background tab), leaving the thumbnails unscaled until it resumes.
    setTimeout(update, 30);
  }

  new MutationObserver(function (records) {
    for (var i = 0; i < records.length; i++) {
      var el = records[i].target;
      if (el.nodeType === 1 && el.closest && el.closest('.tee-gallery-content')) {
        schedule();
        return;
      }
      if (records[i].type === 'childList') {
        schedule();
        return;
      }
    }
  }).observe(document.body, {
    childList: true,
    subtree: true,
    attributes: true,
    attributeFilter: ['class', 'style']
  });

  window.addEventListener('resize', schedule);
  schedule();
})();
